import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: unit * 2,
    },
});

function ScannedFaceData(props) {
    return (
        <Grid
            container
            spacing={0}
        >
            <Grid
                item
                xs={12}
                sm={12}
            >
                <Grid
                    container
                    spacing={0}
                >
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.name}
                        </Typography>
                        <Typography variant="caption">
                            Name
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.surname}
                        </Typography>
                        <Typography variant="caption">
                            Surname
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.address.street}
                        </Typography>
                        <Typography variant="caption">
                            Residental Address
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.address.city}
                        </Typography>
                        <Typography variant="caption">
                            City
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.address.postalCode}
                        </Typography>
                        <Typography variant="caption">
                            Postal Code
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                    >
                        <Typography variant="subheading">
                            {props.applicant.dateOfBirth}
                        </Typography>
                        <Typography variant="caption">
                            Date of birth
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
            >
                <Button
                    className={props.classes.button}
                    onClick={() => {
                        props.setApplicantScannedId(false);
                    }}
                >
                    Retake
                </Button>
            </Grid>
        </Grid>
    );
}

ScannedFaceData.propTypes = {
    setApplicantScannedId: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    applicant: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScannedFaceData);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/ScannedIdData.js